import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // 1. Validar autenticación
    if (!this.auth.estaAutenticado()) {
      console.log('Usuario no autenticado, redirigiendo a login');
      this.auth.logout();
      this.router.navigateByUrl('login');
      return false;
    }

    // 2. Validar roles si la ruta los requiere
    const requiredRoles = route.data['roles'] as Array<string>;
    console.log('=== AuthGuard Debug ===');
    console.log('URL:', state.url);
    console.log('Required roles:', requiredRoles);
    
    // Si la ruta no requiere roles específicos, permitir acceso
    if (!requiredRoles || requiredRoles.length === 0) {
      console.log('No se requieren roles específicos, acceso permitido');
      return true;
    }

    // Obtener roles del usuario
    const userRoles = this.auth.getUserRoles();
    console.log('User roles:', userRoles);

    // Verificar si el usuario tiene al menos uno de los roles requeridos
    const hasAccess = requiredRoles.some(role => 
      userRoles.some(userRole => 
        userRole.toUpperCase() === role.toUpperCase()
      )
    );

    if (!hasAccess) {
      console.warn('Acceso denegado - Usuario no tiene los roles necesarios');
      console.warn('Roles requeridos:', requiredRoles);
      console.warn('Roles del usuario:', userRoles);
      
      this.router.navigateByUrl('home/comisiones');
      return false;
    }

    console.log('Acceso permitido ✓');
    return true;
  }
}